import type { InclusionOption, OperatorOption } from "app/pages/sales-intelligence/types/commonMaps";

export const sdkContentTypeMap = {
    category: "category",
    sdk: "sdk",
} as const;
export type SdkContentType = (typeof sdkContentTypeMap)[keyof typeof sdkContentTypeMap];

export interface IAppsSDKsFilterItem {
    readonly inclusion: InclusionOption;
    readonly operator: OperatorOption;
    readonly categories: readonly string[];
    readonly sdks: readonly string[];
}
